import { TypeformForm } from '@/api/model/typeform/typeform-form'
import { TypeformMap } from '@/api/model/typeform/typeform-map'

export class TypeformWelcomeScreen {
    constructor(
        public id: string,
        public ref: string,
        public title: string,
        public properties: TypeformMap,
        public attachment: TypeformMap|null,
        public layout: TypeformMap|null,
    ) {
        this.initProperties(this.properties)
    }

    get description(): string {
        return this.properties.description as string
    }

    set description(description: string) {
        this.properties.description = description
    }

    get type(): string {
        return 'welcome_screen'
    }

    initProperties(properties: TypeformMap = {}): void {
        const propertyDefinitions = {
            description: { default: '' },
            show_button: { default: false },
            button_text: { default: '' },
        }

        for (const property of Object.keys(propertyDefinitions)) {
            const propertyDefinition = propertyDefinitions[property]

            const currentValue = property in this.properties ? this.properties[property] : null
            const defaultValue = 'default' in propertyDefinition ? propertyDefinition.default : null

            properties[property] = currentValue ?? defaultValue
        }

        this.properties = properties
    }

    getAllowedReferenceOptions(form: TypeformForm, valueCallback: (type: string, value: string) => string, allowSelf: boolean = false) {
        const options = []

        // All hidden fields
        form.hidden.forEach(hidden => {
            options.push({
                label: hidden,
                value: valueCallback('hidden', hidden),
            })
        })

        return options
    }

    getAllowedReferences(form: TypeformForm, valueCallback: (type: string, value: string) => string, allowSelf: boolean = false) {
        return this.getAllowedReferenceOptions(form, valueCallback, allowSelf).map(allowedReference => allowedReference.value)
    }

    toRequestData(): TypeformMap {
        const requestData: TypeformMap = {
            id: this.id,
            ref: this.ref,
            title: this.title,
            properties: this.properties,
        }

        if (this.attachment) {
            requestData.attachment = this.attachment
        }

        if (this.layout) {
            requestData.layout = this.layout
        }

        return requestData
    }

    static fromData(data: any): TypeformWelcomeScreen {
        if (data === null || typeof data === 'string' || data instanceof TypeformWelcomeScreen) {
            return data
        }

        return new TypeformWelcomeScreen(
            data.id,
            data.ref,
            data.title || '',
            data.properties || {},
            data.attachment,
            data.layout,
        )
    }
}
